import Response from '../base/Response';

export default class ErrorResponse extends Response {

}
